import '../src/App';
import { trackLogin } from '../src/adapter/tracking/tracking';

trackLogin();
